import React from 'react';
import { Section } from './ui/Section';
import { TropicalLeaf } from './botanical/TropicalLeaf';
export function NewProblem() {
  return <Section className="bg-cream relative overflow-hidden py-20" data-id="element-223">
      <TropicalLeaf className="absolute -bottom-32 -right-32 w-[500px] h-[500px] text-moss opacity-5 blur-lg -rotate-45 pointer-events-none" aria-hidden="true" data-id="element-224" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-225">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-forest-deep mb-10 text-center" data-id="element-226">
          ¿Te resulta familiar esta situación?
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-forest/80 leading-relaxed bg-white/60 p-8 rounded-2xl border border-sage-mist/50 shadow-sm" data-id="element-227">
          <p className="flex items-start gap-3" data-id="element-228">
            <span className="text-2xl shrink-0" data-id="element-229">📱</span>
            <span data-id="element-230">
              Alguien en casa se siente mal y lo primero que hacés es{' '}
              <strong data-id="element-231">buscar en Google</strong>.
            </span>
          </p>
          <p className="flex items-start gap-3" data-id="element-232">
            <span className="text-2xl shrink-0" data-id="element-233">😕</span>
            <span data-id="element-234">
              Encontrás <strong data-id="element-235">información contradictoria</strong>. Una página
              dice una cosa, otra dice lo contrario.
            </span>
          </p>
          <p className="flex items-start gap-3" data-id="element-236">
            <span className="text-2xl shrink-0" data-id="element-237">⏳</span>
            <span data-id="element-238">
              <strong data-id="element-239">Perdés tiempo</strong> valioso leyendo artículos
              interminables sin llegar a una conclusión.
            </span>
          </p>
          <p className="flex items-start gap-3" data-id="element-240">
            <span className="text-2xl shrink-0" data-id="element-241">😰</span>
            <span data-id="element-242">
              Terminás <strong data-id="element-243">sintiéndote insegura</strong>, sin saber
              realmente qué hacer o si lo que vas a probar es seguro.
            </span>
          </p>
        </div>
      </div>
    </Section>;
}